// Used by the auth and storage emulators and localApi server proxy
const localIp = '127.0.0.1';
export default localIp;
